// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/finanziamenti/:id',
    requestBody: null,
    response: '{ finanziamento: {...} }'
  },
  {
    method: 'GET',
    endpoint: '/api/banche?societaId=',
    requestBody: null,
    response: '[{ id, nome }]'
  },
  {
    method: 'PUT',
    endpoint: '/api/finanziamenti/:id',
    requestBody: '{...}',
    response: '{ finanziamento: {...} }'
  },
  {
    method: 'PUT',
    endpoint: '/api/finanziamenti/:id/tasso',
    requestBody: '{ nuovoTasso, dataDecorrenza, motivazione }',
    response: '{ ok: true }'
  },
  {
    method: 'PUT',
    endpoint: '/api/finanziamenti/:id/rate/:rataId',
    requestBody: '{ importoRata, notaManuale }',
    response: '{ ok: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/finanziamenti/:id/allegati',
    requestBody: 'FormData',
    response: '{ ok: true, allegato: {...} }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/finanziamenti/:id/allegati/:allegatoId',
    requestBody: null,
    response: '{ ok: true }'
  },
  {
    method: 'GET',
    endpoint: '/api/movimenti-finanziamento/rate-disponibili?finanziamentoId=&includiId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, numeroRata, dataScadenza, importoRata, quotaCapitale, quotaInteressi }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/movimenti-finanziamento',
    requestBody: '{ finanziamentoId, dataPagamento, quotaCapitale, quotaInteressi, spese, cadenzaCompetenza, modalitaCompetenza, periodoCompetenzaDa, periodoCompetenzaA, rataTeoricaId, note }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'GET',
    endpoint: '/api/finanziamenti/:id/allegati/:allegatoId/download',
    requestBody: null,
    response: 'file stream (attachment)'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
